import classNames from "classnames";
import ScrollableBadgesRow from "PFComponents/badges_list/scrollable_badges_row";
import { useCurrentProfile } from "PFCore/hooks/queries/profile/use_current_profile";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import css from "./taylor_feed.less";

const CLICKED_EDIT_FLAG = "TaylorFeed_clicked_edit_flag";
const setClickedFlagOn = () => storage && storage.setItem(CLICKED_EDIT_FLAG, true);

const TaylorFeed = ({ saveInterestedSkill }) => {
  const { data: currentProfile } = useCurrentProfile();
  const { t } = useTranslation("feed");

  const suggestedSkills = currentProfile.suggestions.skills;
  const allSkills = currentProfile.skills || [];

  const [skills, setSkills] = useState(suggestedSkills.map((item) => ({ text: item.value, id: item.id })));

  if (!suggestedSkills) {
    return null;
  }

  const hasSuggestions = skills.length > 0;

  const addSkill = (skillId) => {
    //call to save the suggested skill
    const skill = skills.find(({ id }) => id === skillId);
    if (skill) {
      skill.isBeingRemoved = true; // triggers animation
      setSkills([...skills]);
    }
    const postPormise = saveInterestedSkill(skillId);
    const waitPromise = new Promise((resolve) => setTimeout(resolve, 1500)); // for animation
    Promise.all([postPormise, waitPromise]).then(() =>
      setSkills((skills) => skills.filter((item) => item.id !== skillId))
    );
  };

  if (hasSuggestions && allSkills.length < 20) {
    return (
      <div className={classNames(css.tailor, css.tailorSuggestions)}>
        <div className={css.tailorText}>
          <Trans i18nKey="tailorYourFeed" t={t} components={[<strong key="1" />, <div key="2" />]} />
        </div>
        <ScrollableBadgesRow values={skills} itemClick={addSkill} />
      </div>
    );
  }

  if ((storage && storage.getItem(CLICKED_EDIT_FLAG)) || allSkills.length === 0) {
    return false;
  }

  return (
    <div className={css.tailor}>
      <strong>{t("thanks")}</strong>
      &nbsp;
      <div>
        <Trans
          i18nKey="enoughInformation"
          t={t}
          components={[
            <Link key="1" to="/profiles/me/skills" onClick={setClickedFlagOn} className={css.link} />
          ]}
        />
      </div>
    </div>
  );
};

TaylorFeed.propTypes = {
  saveInterestedSkill: PropTypes.func
};

export default TaylorFeed;
